import React, { useEffect, useState } from 'react'
import { Card, Table } from 'reactstrap'
import AddPay from './AddPay'
import { getPayinPayOutList } from './service/payment-service';
import MyPagination from '../pagination';
import { useLoader } from '../../_helper/LoaderContext';
import { formatDate } from '../../utils/formatDate';
import { Tooltip } from 'react-tooltip';
import { useCurrency } from '../../_helper/currencyContext';
import { FormLabel } from 'react-bootstrap';

export default function PayinPayoutHome() {
    const [show, setShow] = useState(false);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { setLoading } = useLoader();
    const { getCurrencySymbol, convertCurrency, currency } = useCurrency();
    const [transaction, setTransaction] = useState([]);
    const [payment, setPayment] = useState("");

    const openModel = () => {
        setShow(true);
    }

    useEffect(() => {
        getList()
    }, [currentPage, entriesPerPage, search, payment])

    const getList = async () => {
        setLoading(true)
        try {
            const form_data = new FormData()
            form_data.append("search", search);
            form_data.append("page", currentPage);
            form_data.append("limit", entriesPerPage);
            form_data.append("type", payment);
            const res = await getPayinPayOutList(form_data)
            if (res.data.success == true) {
                setTransaction(res.data.data.transactions)
                setTotalEntries(res.data.data.total || 0);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setEntriesPerPage(newSize);  // Use the correct setter
        setCurrentPage(1);           // Reset to page 1
    }

    const getStartingSerialNumber = () => {
        return (currentPage - 1) * entriesPerPage + 1;
    };


    return (
        <>
            <Card>
                <div className="tw-px-3 tw-py-4">
                    <div className="row mb-2">
                        <div className="col-md-3">
                            <select className='form-select' value={payment} onChange={(e) => setPayment(e.target.value)}>
                                <option value="">Select</option>
                                <option value="payIn">Pay In</option>
                                <option value="payOut">Pay Out</option>
                            </select>
                        </div>
                        <div className="col-md-9 text-end">
                            <button className='btn btn-primary' onClick={openModel}>Add</button>
                        </div>
                    </div>
                    {/* <div className="d-flex mb-2 tw-justify-end">
                        <select className='form-select' value={payment} onChange={(e) => setPayment(e.target.value)}>
                            <option value="">Select</option>
                            <option value="payIn">Pay In</option>
                            <option value="payOut">Pay Out</option>
                        </select>
                        <button className='btn btn-primary' onClick={openModel}>Pay</button>
                    </div> */}
                    <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black"
                    >
                        <Table className="mb-0 table-center table-bordered table-hover" style={{ overflowX: "auto", tableLayout: "fixed" }}>
                            <thead>
                                <tr>
                                    <th className="text-center bg-primary tw-text-center" style={{
                                        width: "80px"   // 👈 add width only to first column
                                    }}>
                                        <b>#</b>
                                    </th>
                                    {/* <th className="bg-primary text-white" style={{ width: "10px" }}><b>#</b></th> */}
                                    <th className="bg-primary text-white" style={{ width: "160px" }}><b>Transaction Type</b></th>
                                    <th className="bg-primary text-white" style={{ width: "80px" }}><b>Credit</b></th>
                                    <th className="bg-primary text-white" style={{ width: "80px" }}><b>Debit</b></th>
                                    <th className="bg-primary text-white" style={{ width: "160px" }}><b>Balance</b></th>
                                    <th className="bg-primary text-white" style={{ width: "100px" }}><b>Date</b></th>
                                    <th className="bg-primary text-white" style={{ width: "80px" }}><b>Paid In</b></th>
                                    {/* <th className="bg-primary text-white text-center" style={{ width: "80px" }}><b>Action</b></th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {transaction.length > 0 ? (
                                    transaction.map((item, index) => {
                                        const serialNumber = getStartingSerialNumber() + index;
                                        const tooltipId = `tooltip-${item._id}`;
                                        return (
                                            <tr key={item._id} className={index % 2 === 0 ? '' : ''}>
                                                <td className="text-center font-weight-bold">
                                                    {serialNumber}
                                                </td>
                                                <td className="tw-px-3 tw-py-3">
                                                    <div className="tw-font-bold tw-text-gray-900 text-capitalize tw-ps-3">
                                                        <span className={item.actionType === "payOut" ? "text-danger" : "text-success"}>
                                                            {item.actionType === "payOut" ? "Pay Out" : "Pay In"}
                                                        </span>

                                                        {/* Info icon with UNIQUE tooltip */}
                                                        <i
                                                            className="bi bi-info-circle tw-ml-2 tw-cursor-pointer tw-text-primary"
                                                            data-tooltip-id={tooltipId}
                                                            data-tooltip-content={item.reason || "No reason provided"}
                                                        />
                                                        <Tooltip id={tooltipId} place="top" />
                                                    </div>
                                                </td>
                                                <td className='text-success fw-bold'>
                                                    {item.transactionType == "credit" ? (
                                                        <>
                                                            {getCurrencySymbol(item.currencyType)}{item.amount}
                                                        </>
                                                    ) : (
                                                        <div>-- </div>
                                                    )}
                                                </td>
                                                <td className='text-danger fw-bold'>
                                                    {item.transactionType == "debit" ? (
                                                        <>
                                                            {getCurrencySymbol(item.currencyType)}{item.amount}
                                                        </>
                                                    ) : (
                                                        <div>-- </div>
                                                    )}
                                                </td>
                                                <td className='fw-bold'>
                                                    {item.currencyType && item.wallets
                                                        ? `${getCurrencySymbol(item.currencyType)}${Number(item.wallets[item.currencyType]).toFixed(2)}`
                                                        : "-"}
                                                </td>
                                                <td>
                                                    {formatDate(item.createdAt)}
                                                </td>
                                                <td>
                                                    <div className="fw-bold"> {item.currencyType}</div>
                                                </td>
                                                {/* <td className="tw-px-4 tw-py-4 text-center">
                                                    <div className="">
                                                        <button className='success-action-button me-1' data-tooltip-id="invoice">
                                                            <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
                                                        </button>
                                                    </div>
                                                </td> */}
                                            </tr>
                                        )
                                    })
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={7}
                                            className="text-center py-4 text-muted"
                                        >
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    <div className="d-md-flex align-items-center text-center justify-content-between mt-3 mb-3">
                        <div className="show-entries">
                            <FormLabel>Show&nbsp;</FormLabel>
                            <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={entriesPerPage}
                                onChange={handlePageSizeChange} className="form-control">
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={30}>30</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                            </select>&nbsp;
                            <FormLabel>entries</FormLabel>
                        </div>
                        <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
                    </div>
                    {/* <div className="mt-3">
                        <MyPagination totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={(page) => setCurrentPage(page)}></MyPagination>
                    </div> */}
                </div>
            </Card>
            <AddPay show={show} onHide={() => setShow(false)} getList={getList} />
        </>
    )
}
